export default "__VITE_ASSET__BHeDjdVu__"